import getRuleError from "../utils/getRuleError";
import getRuleValue from "../utils/getRuleValue";
import {translate} from "../../../../i18n";
import {timeIsNull} from "../../../../utils/time-hms/index";

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired();
}

function checkRequired() {
    const {required} = $rules;
    const {hasSeconds} = $options;

    const ruleValue = getRuleValue(required, $allValues);
    const ruleError = getRuleError(required, $allValues, translate('Required'));

    if (ruleValue === true) {
        if (timeIsNull($value, hasSeconds)) {
            return ruleError;
        }
    }

    return null;
}
